import { FeatureFlags } from '@fabric-ui/components';
import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/_externalProjectionsLayout/calc-dims/')({
  validateSearch: zodValidator(withDefaults(schema.CALC_DIMS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const {
      userPermissions: { hasAllowedPermission, isInternalRole },
    } = context;

    const isAllowed =
      (isInternalRole || hasAllowedPermission({ path: PAGE_PATHS.CALC_DIMS })) &&
      !!context.featureFlags[FeatureFlags.ShowCalculatedDimensionsPage];
    context.validatePermissions({ isAllowed, preload });
  },
});
